import { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const MainHeader = () => {
  const [DashboardMenu, setDashboardMenu] = useState(false);
  const [ReportMenu, setReportMenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navRef = useRef(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
    window.location.reload();
  };

  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setDashboardMenu(false);
        setReportMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="w-100 main-header">
        <nav className="nav">
          <div className="logo-section">
            <div style={{
              background: '#fff',
              borderRadius: 8,
              padding: '4px 12px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <img
                src="/assets/img/amscl_logo.png"
                alt="AMSCL Logo"
                style={{ height: 42, objectFit: 'contain' }}
              />
              <span style={{
                fontSize: '7px', fontWeight: 700, color: '#1a3c6e',
                letterSpacing: '0.5px', marginTop: 1, whiteSpace: 'nowrap'
              }}>
                ISO 9001:2015 Certified
              </span>
            </div>
            <span style={{
              color: '#fff', fontWeight: 700, fontSize: '1rem',
              marginLeft: 12, letterSpacing: '0.3px', whiteSpace: 'nowrap'
            }}>
              Assam Logistic Management Information System (LMIS)
            </span>
          </div>
          {!mobileMenuOpen && (
        <div className="live-data">
          <div className="live-data-text">
            <span></span>Live data
          </div>
          <div className="state-name">Assam State</div>
          <p className="last-updated">Last updated: 3 Mar 2026, 09:45 AM</p>
          {currentUser.name && (
            <button onClick={handleLogout} style={{
              marginLeft: 16, padding: '6px 16px', borderRadius: 6,
              border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)',
              color: '#fff', fontSize: '.75rem', fontWeight: 600, cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => { e.currentTarget.style.background = 'rgba(239,68,68,0.8)'; }}
            onMouseOut={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
            >
              Logout
            </button>
          )}
        </div>
      )}
          {/* Hamburger button for mobile */}
          <button className="hamburger-btn" onClick={() => setMobileMenuOpen(true)} aria-label="Open menu">
            &#9776;
          </button>
        </nav>
        <nav className="nav-lists" ref={navRef} style={{ display: mobileMenuOpen ? "none" : "block" }}>
          <ul>
            <li style={{ opacity: 0.5, cursor: 'not-allowed' }}>
              <div className="nav-item dashboard-key">
                Dashboard ▾
              </div>
            </li>
            <li style={{ opacity: 0.5, cursor: 'not-allowed' }}>
              <div className="nav-item relative">
                Reports ▾
              </div>
            </li>
            <li style={{ opacity: 0.5, cursor: 'not-allowed' }}>User Management</li>
            <li style={{ opacity: 0.5, cursor: 'not-allowed' }}>Upload Data</li>
          </ul>
        </nav>
      </header>
      {/* Mobile overlay menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button className="close-mobile" onClick={() => setMobileMenuOpen(false)} aria-label="Close menu">
            &times;
          </button>
          <div className="mobile-live-data">
            <div className="live-data-text">
              <span></span>Live data
            </div>
            <div className="state-name">Assam State</div>
            <p className="last-updated">Last updated: 3 Mar 2026, 09:45 AM</p>
          </div>
          <ul className="mobile-nav-list">
            <li>
              <NavLink className="route-links" to="/state_dashboard" onClick={() => setMobileMenuOpen(false)}>
                State Level Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink className="route-links" to="/district_dashboard" onClick={() => setMobileMenuOpen(false)}>
                District Level Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink className="route-links" to="/facility_dashboard" onClick={() => setMobileMenuOpen(false)}>
                Facility Level Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink className="route-links" to="/heatmap" onClick={() => setMobileMenuOpen(false)}>
                District Heat Map
              </NavLink>
            </li>
            <li>
              <NavLink className="route-links" to="/report1" onClick={() => setMobileMenuOpen(false)}>
                Report 1
              </NavLink>
            </li>
            <li>
              <NavLink className="route-links" to="/report2" onClick={() => setMobileMenuOpen(false)}>
                Report 2
              </NavLink>
            </li>
            <li>
              <NavLink className="route-links" to="/report3" onClick={() => setMobileMenuOpen(false)}>
                Report 3
              </NavLink>
            </li>
            <li>User Management</li>
            <li>Upload Data</li>
          </ul>
        </div>
      )}
    </>
  );
};

export default MainHeader;
